module.exports = __webpack_public_path__ + "static/media/211CS254.13e57b35.jpg";